import * as React from "react";
import { IconButton, TextField } from "@radix-ui/themes";
import { PaperPlaneIcon } from "@radix-ui/react-icons";
import { useMutation } from "convex/react";
import { api } from "@repo/convex/convex/_generated/api";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { toast } from "sonner";

interface Props {
  chatId: Id<"itemChats">;
}

export const ChatMessageEntryBox: React.FC<Props> = ({ chatId }) => {
  const [message, setMessage] = React.useState("");
  const createMessage = useMutation(api.itemChatMessages.createMessageForUser);

  return (
    <form
      className="chat-entry"
      onSubmit={(e) => {
        e.preventDefault();
        if (!message.trim()) return;
        createMessage({ message, chatId }).catch(toast.error);
        setMessage("");
      }}
    >
      <TextField.Root
        size="3"
        placeholder="Ask about it"
        aria-label="Message"
        autoFocus
        onChange={(e) => setMessage(e.target.value)}
        value={message}
      >
        <TextField.Slot side={"right"} pr={"1"}>
          <IconButton type={"submit"} aria-label="Send" disabled={!message.trim()}>
            <PaperPlaneIcon />
          </IconButton>
        </TextField.Slot>
      </TextField.Root>
    </form>
  );
};
